import { createIcon } from '@chakra-ui/react'

export const ApproveIcon = createIcon({
  displayName: 'ApproveIcon',
  path: (
    <>
      <path
        d='M0.341797 11.175L5.00013 15.8334L6.17513 14.65L1.52513 10L0.341797 11.175ZM18.5335 4.65002L9.7168 13.475L6.25013 10L5.05846 11.175L9.7168 15.8334L19.7168 5.83336L18.5335 4.65002ZM15.0001 5.83336L13.8251 4.65002L8.53346 9.94169L9.7168 11.1167L15.0001 5.83336Z'
        fill='currentColor'
      />
    </>
  ),
  viewBox: '0 0 20 20',
})
